/**
 * Served game art: images the games server hosts at content-hashed URLs rather
 * than the apps bundling them (see apps/api-server/scripts/publish-game-art.ts).
 *
 * Ids are the image's path under `served/` (`trl/sabotage/con_clue.webp`), checked
 * at compile time against the generated manifest. Registries name art by id and
 * turn it into a URL here, at call time, through the app's resolver:
 *   - admin-web prefixes its API origin;
 *   - the Electron renderers also route it through their disk-cache protocol.
 * Each app calls {@link configureArtUrl} once, before it renders.
 */
import { ART_MANIFEST } from './generated/artManifest.generated';
let resolveUrl = (path) => path;
/** Set how an art path (`/assets/static/…`) becomes a URL an `<img>` can load. */
export function configureArtUrl(resolver) {
    resolveUrl = resolver;
}
/** The URL of a piece of served art. */
export function artUrl(id) {
    return resolveUrl(ART_MANIFEST[id]);
}
/** Whether `id` names served art (for ids built at runtime, e.g. from a flashpoint name). */
export function isArtAssetId(id) {
    return Object.prototype.hasOwnProperty.call(ART_MANIFEST, id);
}
